import { graphql } from 'gql';

export const uerWorkOrderMtrRowsForComparisonGql = graphql(`
    query uerWorkOrderMtrRowsForComparison($workOrderPriceId: Long!, $where: PriceListMtrRowDataFilterInput) {
        uerWorkOrderMtrRowsForComparison(workOrderPriceId: $workOrderPriceId, where: $where) {
            items {
                key
                code
                contractId
                hasDuplicateNeighbours
                id
                isIncludedInAct
                isIncludedInWorkOrder
                justification
                mtrSupplyAndType
                mtrType
                name
                note
                pricingType
                status
                supplyBasis
                supplyBy
                unit
                unitCost
                unitWeight
                volume
            }
        }
    }
`);

export const uerWorkOrderPriceListMtrAssignCodeFilterGql = graphql(`
    query uerWorkOrderPriceListMtrAssignCodeFilter(
        $contractId: Long!
        $mtrRowId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListMtrAssignCodeFilter(contractId: $contractId, mtrRowId: $mtrRowId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderPriceListMtrAssignNameFilterGql = graphql(`
    query uerWorkOrderPriceListMtrAssignNameFilter(
        $contractId: Long!
        $mtrRowId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceListMtrAssignNameFilter(contractId: $contractId, mtrRowId: $mtrRowId, where: $where) {
            items {
                value
            }
        }
    }
`);
